<template lang="pug">
.copyright.bg-dark
  .container.h-100
    .row.d-flex.justify-content-between.align-items-center(:class="{'flex-column':viewportWidth <= 640}")
      .col-md-7.text-md-left.text-center
        p.text-white(:class="{'mb-0':viewportWidth > 640}") 永豐雲端印刷網，給你的 質感印刷提案
      .col-md-5.text-md-right.text-center
        p.ml-md-5.text-white(:class="{'mb-0':viewportWidth > 640}") Copyright © {{fullyear}} YUEN FOONG PAPER CO.,LTD. 永豐紙業 All rights reserved<br/>永豐紙業股份有限公司<br/>統一編號：38019423

</template>
// TODO 20221122 copyright flex
<script>
export default {
  props: ['viewportWidth'],
  data () {
    return {
      fullyear: '',
      version: window.version
    }
  },
  created () {
    let d = new Date()
    this.fullyear = d.getFullYear()
  }
}
</script>
<style lang="scss" scoped>
.copyright {
  font-size: 13px;
  padding: 20px 0;
}
p:nth-child(2) {
  margin-bottom: 0;
}
//p:nth-child(2) 無影響
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1395px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/copyright.vue